<template>
  <div class="ad-root">
    <img :src="img" >
    <div class="btn-wrap">
      <div class="btn">
        <Button size="large" to="/onlineServe" color="linear-gradient(to right, #4bb0ff, #6149f6)">帮我报价</Button>
      </div>
      <div class="btn">
        <Button size="large" to="/onlineServe" color="linear-gradient(to right, #4bb0ff, #6149f6)">马上预约</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img:require('../../assets/images/online.png')
    }
  },
  created() {
    document.title = '上门服务'
  }
}
</script>

<style lang="less" scoped>
.ad-root {
  position: relative;
  height: 100%;
  overflow: auto;
  img {
    width:100%;
  }
  .btn-wrap {
    // position: fixed;
    // bottom: 20px;
    padding: 20px 0;
    width: 100%;
    display: flex;
    background: #ffffff;
    justify-content: space-around;
    .btn {
      width: 40%;
      padding: 0 10px;
    }
  }
}
</style>